import { CloudItem } from 'reactApp/modules/storage/storage.types';
import { ActionName } from 'reactApp/ui/VirusDialog/VirusDialog.types';

export const popupNames = {
    CO_EDIT_ALERT: 'CO_EDIT_ALERT',
    SPACE_PROMO: 'SPACE_PROMO',
    WEB_PUSH_TOOLTIP: 'WEB_PUSH_TOOLTIP',
    DOWNLOAD_DLG: 'DOWNLOAD_DLG',
    VIRUS_DLG: 'VIRUS_DLG',
    NO_WARNING: 'NO_WARNING',
    DISABLED_FEATURE: 'DISABLED_FEATURE',
    RECOGNITION_POPUP: 'RECOGNITION_POPUP',
    FILE_HISTORY: 'FILE_HISTORY',
    SELECT_FOLDER_DIALOG: 'SELECT_FOLDER_DIALOG',
    SELECT_PATH_DIALOG: 'SELECT_PATH_DIALOG',
    REMOVE_DIALOG: 'REMOVE_DIALOG',
    RENAME_DIALOG: 'RENAME_DIALOG',
    ASK_NAME_DIALOG: 'ASK_NAME_DIALOG',
    CREATE_FOLDER: 'CREATE_FOLDER',
    UPDATE_CARD: 'UPDATE_CARD',
    TARIFF_BUY: 'TARIFF_BUY',
    CONFIRM_EMAIL_SCREEN: 'CONFIRM_EMAIL_SCREEN',
    CONFIRM_EMAIL_DIALOG: 'CONFIRM_EMAIL_DIALOG',
    CANCEL_MAIL_SUBSCRIPTION: 'CANCEL_MAIL_SUBSCRIPTION',
    VKBUY_MODAL: 'VKBUY_MODAL',
    MOUNT_DIALOG: 'MOUNT_DIALOG',
    UNMOUNT_DIALOG: 'UNMOUNT_DIALOG',
    REJECT_DIALOG: 'REJECT_DIALOG',
    SHARING_DIALOG: 'SHARING_DIALOG',
    SHARING_MODIFIED: 'SHARING_MODIFIED',
    OVERQUOTA_BANNER: 'OVERQUOTA_BANNER',
    DATALIST: 'DATALIST',
    DOWNLOAD_MOBILE: 'DOWNLOAD_MOBILE',
    MOBILE_OPTIONS: 'MOBILE_OPTIONS',
    MOBILE_FILTER_AUTHOR: 'MOBILE_FILTER_AUTHOR',
    MOBILE_FILTER_FACES: 'MOBILE_FILTER_FACES',
    MOBILE_VIEWER: 'MOBILE_VIEWER',
    AUTH_MODAL: 'AUTH_MODAL',
    MOBILE_VIRUS_DIALOG: 'MOBILE_VIRUS_DIALOG',
    MOBILE_FILE_INFO_MODAL: 'MOBILE_FILE_INFO_MODAL',
    MOBILE_SUSPICIOS_DIALOG: 'MOBILE_SUSPICIOS_DIALOG',
    MOBILE_GIFT_PROMOCODE_DIALOG: 'MOBILE_GIFT_PROMOCODE_DIALOG',
    MOBILE_SPLASH_SCREEN: 'MOBILE_SPLASH_SCREEN',
    MOBILE_LEFT_MENU: 'MOBILE_LEFT_MENU',
    SUSPICIOS_DIALOG: 'SUSPICIOS_DIALOG',
    SELECT_ALBUM: 'SELECT_ALBUM',
    DISABLE_ADS_PROMO: 'DISABLE_ADS_PROMO',
    SPECIAL_BANNER: 'SPECIAL_BANNER',
    WHATS_NEW_DIALOG: 'WHATS_NEW_DIALOG',
    CONFIRM_EMAIL_MOBILE: 'CONFIRM_EMAIL_MOBILE',
    EMERGENCY_SWA: 'EMERGENCY_SWA',
    BANNER_OFFER: 'BANNER_OFFER',
    SUBSCRIPTIONS_MOBILE: 'SUBSCRIPTIONS_MOBILE',
    SUBSCRIPTION_INFO_MOBILE: 'SUBSCRIPTION_INFO_MOBILE',
    SELECT_FROM_CLOUD_DIALOG: 'SELECT_FROM_CLOUD_DIALOG',
    SUBSCRIPTION_CANCEL_AUTO_RENEWAL_MOBILE: 'SUBSCRIPTION_CANCEL_AUTO_RENEWAL_MOBILE',
    SUBSCRIPTION_CANCEL_SUBSCRIPTION_MOBILE: 'SUBSCRIPTION_CANCEL_SUBSCRIPTION_MOBILE',
    SUBSCRIPTION_CANCEL_WITH_CAPTCHA: 'SUBSCRIPTION_CANCEL_WITH_CAPTCHA',
    FACEBOOK_MUST_ATTACH_PHONE: 'FACEBOOK_MUST_ATTACH_PHONE',
    SUCCESS_ATTACH_PHONE: 'SUCCESS_ATTACH_PHONE',
    PAY_IN_BROWSER: 'PAY_IN_BROWSER',
    CLEAR_TRASHBIN: 'CLEAR_TRASHBIN',
    MOBILE_DOWNLOAD_APP: 'MOBILE_DOWNLOAD_APP',
    POLL_DIALOG: 'POLL_DIALOG',
    DELETE_CONFIRMATION_DIALOG: 'DELETE_CONFIRMATION_DIALOG',
    QUOTA_CLEANER_PAGE: 'QUOTA_CLEANER_PAGE',
    QUOTA_MOBILE_NAVIGATION: 'QUOTA_MOBILE_NAVIGATION',
    GENERIC_CONFRIMATION_DIALOG: 'GENERIC_CONFRIMATION_DIALOG',
    UPLOAD_BIG_FILE: 'UPLOAD_BIG_FILE',
    QUOTA_POPUP: 'QUOTA_POPUP',
    REMOVE_CARD: 'REMOVE_CARD',
    PRE_COPY_WEBLINK: 'PRE_COPY_WEBLINK',
    SUBSCRIPTION_MODAL: 'SUBSCRIPTION_MODAL',
    // tempexp_14269-next-line
    FREEZE_RENEWAL: 'FREEZE_RENEWAL',
    MOBILE_USER_CHANGE_MODAL: 'MOBILE_USER_CHANGE_MODAL',
    MOBILE_USER_LOGIN_MENU: 'MOBILE_USER_LOGIN_MENU',
    VIOLATED_FILENAME: 'VIOLATED_FILENAME',
    MOBILE_SEARCH_NOTIFICATION: 'MOBILE_SEARCH_NOTIFICATION',
    MOBILE_SEARCH_HISTORY_NOTIFICATION: 'MOBILE_SEARCH_HISTORY_NOTIFICATION',
    MOBILE_CLOUD_NEW_FEATURES: 'MOBILE_CLOUD_NEW_FEATURES',
    ASIDE_PROMO_MODAL: 'ASIDE_PROMO_MODAL',
    BUY_BUSINESS_DIALOG: 'BUY_BUSINESS_DIALOG',
    AUTH_DIALOG: 'AUTH_DIALOG',
    SMALL_WINDOW_WARNING_DIALOG: 'SMALL_WINDOW_WARNING_DIALOG',
    FAMILY_SUBSCRIPTION_PROMO: 'FAMILY_SUBSCRIPTION_PROMO',
    PROMOCODE_RESULT: 'PROMOCODE_RESULT',
    BUY_MODAL: 'BUY_MODAL',
} as const;

export interface PopupHelper {
    closeDialog(): void;
}

export interface PopupStateData {
    name: string;
    data: any;
}

export interface IVirusDialogRequest {
    items: CloudItem | CloudItem[];
    actionName?: ActionName;
    name?: string;
    doNotChangeRoute?: boolean;
}
